import React from 'react';
import styled from 'styled-components';
import PortoLogo from '../assets/logo-portoseguro.png';
import AllianzLogo from '../assets/logo-allianz.png';
import azulLogo from '../assets/logo-azul.png';
import bradescoLogo from '../assets/logo-bradesco.png';
import multiplaLogo from '../assets/logo-multipla.png';

const InsuranceContainer = styled.section`
  padding: 80px 0;
  background: #f9f9f9;
  text-align: center;
`;

const InsuranceH1 = styled.h1`
  font-size: 2.5rem;
  color: #4F4C4C;
  margin-bottom: 64px;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

const LogoWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 40px;
  padding: 0 20px;
`;

const LogoImg = styled.img`
  height: 60px;
  filter: grayscale(100%);
  opacity: 0.7;
  transition: all 0.3s ease-in-out;

  &:hover {
    filter: grayscale(0%);
    opacity: 1;
  }
`;

const Insurance = () => {
  return (
    <InsuranceContainer id="insurance">
      <InsuranceH1>Trabalhamos com as Principais Seguradoras</InsuranceH1>
      <LogoWrapper>
        <LogoImg src={PortoLogo} alt="Porto Seguro" />
        <LogoImg src={AllianzLogo} alt="Allianz" />
        <LogoImg src={bradescoLogo} alt="Bradesco Seguros" />
        <LogoImg src={azulLogo} alt="Azul Seguros" />
        <LogoImg src={multiplaLogo} alt="Multipla Seguros" />
      </LogoWrapper>
    </InsuranceContainer>
  );
};

export default Insurance;